var $e254601d3b112ae8$exports = {};
$e254601d3b112ae8$exports = {
    "clear": `Ryd`,
    "invalid": `(ugyldig)`,
    "loading": `Indl\xe6ser ...`,
    "noResults": `Ingen resultater`
};


export {$e254601d3b112ae8$exports as default};
//# sourceMappingURL=da-DK.module.js.map
